import { useOnErrorScreen } from '../services/useOnErrorScreen';
export var useErrorScreen = function (config, logger) {
    return function (params) {
        var fallback = params.fallback, _a = params.data, data = _a === void 0 ? {} : _a;
        if (config.isMiniApp) {
            logger.debug('[useErrorScreen] - Using on error screen service');
            useOnErrorScreen(data, logger);
        }
        else {
            logger.debug('[useErrorScreen] - Using fallback function');
            fallback();
        }
    };
};
